import { withConsole as withConsole$1, setConsole as setConsole$1, consoleWith as consoleWith$1, assert as assert$1, clear as clear$1, count as count$1, countReset as countReset$1, debug as debug$1, dir as dir$1, dirxml as dirxml$1, error as error$1, group as group$1, info as info$1, log as log$1, table as table$1, time as time$1, timeLog as timeLog$1, trace as trace$1, warn as warn$1, withGroup as withGroup$1, withTime as withTime$1 } from '../../internal/console.esm.js';
import { TypeId as TypeId$1 } from '../../internal/defaultServices/console.esm.js';

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category type ids
 */
const TypeId = TypeId$1;

/**
 * @since 2.0.0
 * @category type ids
 */

/**
 * @since 2.0.0
 * @category model
 */

/**
 * @since 2.0.0
 * @category model
 */

/**
 * @since 2.0.0
 * @category default services
 */
const withConsole = withConsole$1;

/**
 * @since 2.0.0
 * @category default services
 */
const setConsole = setConsole$1;

/**
 * @since 2.0.0
 * @category accessor
 */
const consoleWith = consoleWith$1;

/**
 * @since 2.0.0
 * @category accessor
 */
const assert = assert$1;

/**
 * @since 2.0.0
 * @category accessor
 */
const clear = clear$1;

/**
 * @since 2.0.0
 * @category accessor
 */
const count = count$1;

/**
 * @since 2.0.0
 * @category accessor
 */
const countReset = countReset$1;

/**
 * @since 2.0.0
 * @category accessor
 */
const debug = debug$1;

/**
 * @since 2.0.0
 * @category accessor
 */
const dir = dir$1;

/**
 * @since 2.0.0
 * @category accessor
 */
const dirxml = dirxml$1;

/**
 * @since 2.0.0
 * @category accessor
 */
const error = error$1;

/**
 * @since 2.0.0
 * @category accessor
 */
const group = group$1;

/**
 * @since 2.0.0
 * @category accessor
 */
const info = info$1;

/**
 * @since 2.0.0
 * @category accessor
 */
const log = log$1;

/**
 * @since 2.0.0
 * @category accessor
 */
const table = table$1;

/**
 * @since 2.0.0
 * @category accessor
 */
const time = time$1;

/**
 * @since 2.0.0
 * @category accessor
 */
const timeLog = timeLog$1;

/**
 * @since 2.0.0
 * @category accessor
 */
const trace = trace$1;

/**
 * @since 2.0.0
 * @category accessor
 */
const warn = warn$1;

/**
 * @since 2.0.0
 * @category accessor
 */
const withGroup = withGroup$1;

/**
 * @since 2.0.0
 * @category accessor
 */
const withTime = withTime$1;

export { TypeId, assert, clear, consoleWith, count, countReset, debug, dir, dirxml, error, group, info, log, setConsole, table, time, timeLog, trace, warn, withConsole, withGroup, withTime };
